import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PublicHeaderSimple() {
  const { t, i18n } = useTranslation();

  function toggleLang() {
    i18n.changeLanguage(i18n.language === 'en' ? 'se' : 'en');
  }

  return (
    <header className="bg-white border-b shadow-sm">
      <div className="max-w-7xl mx-auto h-14 px-4 md:px-8 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2 font-semibold text-lg">
            <div className="text-cyan-600 font-extrabold text-lg tracking-wide">VBWEBB</div>
        </a>

        <nav className="flex items-center gap-2">
          <a
            href="/"
            className="px-3 py-1.5 rounded bg-white text-cyan-700 font-medium hover:opacity-90"
          >
            {t('publicHeaderSimple.login')}
          </a>
          <button
            onClick={toggleLang}
            className="px-2 py-1 rounded hover:bg-gray-100 text-sm"
            type="button"
            aria-label="Toggle language"
          >
            EN/SE
          </button>
        </nav>
      </div>
    </header>
  );
}
